import React from 'react';
import { motion } from 'framer-motion';
import { Parallax } from 'react-scroll-parallax';
import { MapPin, Clock, Compass } from 'lucide-react';
import { nearbyPlaces } from '../mockData';
import './NearbyPlaces.css';

const NearbyPlaces = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section id="nearby-places" className="nearby-section section-padding">
      <div className="container">
        <Parallax speed={-5}>
          <motion.div
            className="nearby-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="heading-1">Explore the Surroundings</h2>
            <p className="body-large">Discover hidden gems and breathtaking destinations near our homestay</p>
          </motion.div>
        </Parallax>

        <motion.div
          className="nearby-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          {nearbyPlaces.map((place, index) => (
            <motion.div
              key={place.id}
              className="nearby-card"
              variants={itemVariants}
              whileHover={{ 
                y: -8,
                transition: { duration: 0.3 }
              }}
            >
              <Parallax speed={index % 2 === 0 ? -3 : 3}>
                <div className="nearby-image-container">
                  <img src={place.image} alt={place.name} className="nearby-image" />
                  <div className="nearby-type-badge">{place.type}</div>
                  <div className="nearby-overlay"></div>
                </div>
              </Parallax>

              <div className="nearby-content">
                <h3 className="heading-3">{place.name}</h3>
                <p className="body-small nearby-description">{place.description}</p>

                <div className="nearby-info">
                  <div className="info-item">
                    <MapPin size={14} />
                    <span>{place.distance}</span>
                  </div>
                  <div className="info-item">
                    <Clock size={14} />
                    <span>{place.duration}</span>
                  </div>
                </div>

                <motion.button
                  className="explore-btn"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <Compass size={16} />
                  <span>Learn More</span>
                </motion.button>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default NearbyPlaces;
